<template>
  <v-form ref="form" v-bind="this.$attrs">
    <div class="mb-2">
      <span class="error--text">*</span> Tài khoản được xử lý theo thông tin tên giáo viên được cung cấp ban đầu. Nếu họ
      tên giáo viên bị thay đổi, nội dung tài khoản cũng bị thay đổi theo.
    </div>

    <v-text-field outlined v-model="teacherUsername" label="Tài khoản" dense disabled></v-text-field>

    <v-text-field
      v-model="password"
      label="Mật khẩu"
      :append-icon="show ? 'visibility' : 'visibility_off'"
      :rules="[$rules.nospace, $rules.required, $rules.minLength(6)]"
      :type="show ? 'text' : 'password'"
      @click:append="show = !show"
      class="required"
      outlined
      dense
    ></v-text-field>
    <v-text-field
      v-model="password2"
      label="Nhập lại mật khẩu"
      :append-icon="show2 ? 'visibility' : 'visibility_off'"
      :rules="[$rules.nospace, $rules.required, $rules.minLength(6), $rules.passInputAgain(password2, password)]"
      :type="show2 ? 'text' : 'password'"
      @click:append="show2 = !show2"
      class="required"
      outlined
      dense
    ></v-text-field>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    formState: Boolean,
    teacherUsername: String
  },
  data: () => ({
    password: '',
    password2: '',
    show: false,
    show2: false
  }),
  computed: {
    ...mapGetters('auth', ['profile'])
  },

  created() {},
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return {
        password: this.password
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  watch: {
    formState(formState) {
      if (!formState) {
        this.password = ''
        this.password2 = ''
      }
    }
  }
}
</script>

<style scoped></style>
